<template>
  <div>
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">저장하기</button>
    </div>
    <div class="columns is-multiline">
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="주문 기본 설정">
            <div class="columns is-multiline">
              <!-- 자동 배송완료 -->
              <div class="column is-full">
                <admin-form-item label="자동배송완료">
                  <lp-radio :val="value.success_delivery"
                            @onSelect="res=> value.success_delivery = res"
                            value_name="value"
                            label_name="label"
                            :data="option_arr1"></lp-radio>
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="value.success_delivery">
                <admin-form-item label="자동 주문 상태변경 일자">
                  <input class="input"
                         style="width:200px"
                         v-model="value.success_delivery_day"
                         @input="e=>setNumber(e, 'success_delivery_day', 3)"
                         type="number">
                </admin-form-item>
              </div>

              <!-- 자동 구매확정-->
              <div class="column is-full">
                <admin-form-item label="자동구매확정">
                  <lp-radio :val="value.success_order"
                            @onSelect="res=> value.success_order = res"
                            value_name="value"
                            label_name="label"
                            :data="option_arr2"></lp-radio>
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="value.success_order">
                <admin-form-item label="자동 주문 상태변경 일자">
                  <input class="input"
                         style="width:200px"
                         v-model="value.success_order_day"
                         @input="e=>setNumber(e, 'success_purchase_day', 3)"
                         type="number">
                </admin-form-item>
              </div>

              <!-- 자동 결제취소-->
              <div class="column is-full">
                <admin-form-item label="자동결제취소">
                  <lp-radio :val="value.cancel_paid"
                            @onSelect="res=> value.cancel_paid = res"
                            value_name="value"
                            label_name="label"
                            :data="option_arr3"></lp-radio>
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="value.cancel_paid">
                <admin-form-item label="자동 주문 상태변경 일자">
                  <input class="input"
                         style="width:200px"
                         v-model="value.cancel_paid_day"
                         @input="e=>setNumber(e, 'cancel_paid_day', 3)"
                         type="number">
                </admin-form-item>
              </div>

            </div>
          </admin-box-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LpRadio from "../../../module/common/LpRadio";

  export default {
    name: 'order-setting',
    components: {LpRadio},
    data() {
      return {
        value: {
          success_delivery: false,
          success_delivery_day: 7,
          success_order: false,
          success_order_day: 7,
          cancel_paid: false,
          cancel_paid_day: 7
        },
        option_arr1:[
          { label: '배송중으로 주문상태 변경한 뒤 배송완료로 자동 주문상태 변경', value: true },
          { label: '사용안함', value: false }
        ],
        option_arr2:[
          { label: '배송완료로 주문상태 변경한 뒤 구매확정으로 자동 주문상태 변경', value: true },
          { label: '사용안함', value: false }
        ],
        option_arr3:[
          { label: '미입금일 경우 결제취소로 자동 주문상태 변경', value: true },
          { label: '사용안함', value: false }
        ]
      }
    },
    created(){
      this.getData();
    },
    methods:{
      setNumber(e, type, max_length){
        if( e.target.value.length > max_length ) this.value[type] = parseInt(e.target.value.substr(0,max_length));
        else this.value[type] = parseInt(e.target.value);
      },
      getData(){
        this.$axios.get(this.getUrl('delivery/order/setting')).then(res=>{
          if(res.status===200){
            this.value = res.data;
          }
        })
      },
      saveData(){
        this.$axios.patch(this.getUrl('delivery/order/setting'), {
          value: this.value
        }).then(res=>{
          if(res.status===200){
            this.toast('저장되었습니다.');
          }
        })
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

</style>
